import {faBan, faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const BooleanValue = ({value}) => (
  value
    ? <FontAwesomeIcon color={'#389e0d'} icon={faCheckCircle}/>
    : <FontAwesomeIcon color={'#595959'} icon={faBan}/>
);

export default BooleanValue;
